import { render } from "./InlineForm.vue?vue&type=template&id=c7755006"
import script from "./InlineForm.vue?vue&type=script&lang=js"
export * from "./InlineForm.vue?vue&type=script&lang=js"
script.render = render

export default script